<live-single-eventlist *ngIf="showLiveList" [_sportName]="'Soccer'" [_selectedOdds]="this._selectedOdds"></live-single-eventlist>

<div class="live-single-content">
  <div class="breadcrumb-container text" (click)="goBack()">
    <div class="breadcrumb-left">
      <image-loader-utils url="up-arrow" extraClasses="arrow-icon left"></image-loader-utils>
    </div>
    <div class="breadcrumb-mid" *ngIf="this._DataHelper.selectedMatch">
      <div class="breadcrumb-tournament-name">
        <ng-container *ngIf="this._DataHelper.selectedMatch?.GroupName === ('MyBets' | translate); else flag">
          <div class="breadcrumb-turnament-icon">
            <image-loader-utils url="my-bets" extraClasses="svg"></image-loader-utils>
          </div>
        </ng-container>
        <ng-template #flag>
          <div class="breadcrumb-turnament-icon">
            <image-loader-flag-utils [url]="this._DataHelper.selectedMatch?.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-flag-utils>
          </div>
        </ng-template>
        <strong class="template-name"> {{ this._DataHelper.selectedMatch?.GroupName }} </strong>
      </div>
    </div>
    <div class="breadcrumb-mid" *ngIf="!this._DataHelper.selectedMatch">
      <div class="breadcrumb-turnament-icon">
        <image-loader-utils url="sports" extraClasses="svg"></image-loader-utils>
      </div>
      <div class="breadcrumb-tournament-noname">
        <strong> {{ 'SPORTS' | translate }} </strong>
      </div>
    </div>
    <div class="breadcrumb-right">
      <image-loader-utils url="star" [extraClasses]="'star-icon '"></image-loader-utils>
    </div>
  </div>

  <div class="p1001-scoreboard-container live-scoreboard text" *ngIf="showLiveList">
    <div class="box match-time">{{ this.event?.TimeStatuColor }} {{ this.event?.MatchTime }}</div>
    <ng-container *ngIf="this._UserHelper.isSignedIn">
      <div class="box first" (click)="addMatch2Favs()">
        <image-loader-utils
          [extraClasses]="'star-icon ' + (this._DataHelper.favList.includes(eventid * 1) ? 'star-icon-active' : 'star-icon-disabled')"
          url="star"></image-loader-utils>
      </div>
    </ng-container>
    <div class="box second">
      {{ this.event?.HomeTeam }}
    </div>
    <div class="box third">
      {{ this.event?.Score }}
    </div>
    <div class="box fourth">
      {{ this.event?.AwayTeam }}
    </div>
    <div class="box fifth" (click)="openHeadToHeadDialog()" *ngIf="-1 * this.eventid < 0">
      <image-loader-utils url="signal" extraClasses="signal-icon"></image-loader-utils>
    </div>
  </div>
  <ng-container *ngIf="('isLiveStream' | getEnv) && this._UserHelper.isSignedIn">
    <div class="liveevent-tab">
      <div class="liveevent-tab-item" [ngClass]="this.selectedTab === 'Tracker' ? 'active' : ''" (click)="setSelectTab('Tracker')">
        <image-loader-utils url="statium" extraClasses="statium-icon"></image-loader-utils>
        <div class="tab-text">{{ 'Tracker' | translate }}</div>
      </div>
      <div
        class="liveevent-tab-item"
        [ngClass]="{ active: this.selectedTab === 'TV', disabled: this.videoUrl === '' || this.videoUrl === 'waiting' || this.videoUrl === 'none' }"
        (click)="setSelectTab('TV')">
        <image-loader-utils url="tv" extraClasses="live-icon"></image-loader-utils>
        <div class="tab-text">{{ 'TV' | translate }}</div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="this.selectedTab === 'TV'">
    <div class="iframe-loader-container">
      <div *ngIf="this.iframeLoading" id="loader" class="iframeLoader v1"></div>
      <ng-container *ngIf="this.videoUrl">
        <iframe
          [style.visibility]="this.iframeVisibility"
          width="100%"
          height="307"
          [src]="sanitizedUrl"
          frameborder="0"
          style="visibility: hidden"
          (load)="this.hideLoader()"
          allow="autoplay; gyroscope; "></iframe>
      </ng-container>
    </div>
  </ng-container>
  <div [ngClass]="this.selectedTab === 'TV' ? 'd-none' : ''">
    <div class="widgets">
      <div>
        <div *ngIf="isOpenTracker" class="sr-widget sr-widget-1"></div>
      </div>
      <iframe *ngIf="this.enableBetGeniusTracker" scrolling="no" id="betgenius-iframe" [src]="sanitizedUrl" width="100%" height="289"></iframe>
    </div>
  </div>
  <div class="event-detail-tab">
    <div class="event-detail-tab-item">
      <div class="right">
        <div id="search">
          <input
            [(ngModel)]="searchValue"
            (input)="searchOdd(searchValue)"
            #search
            type="search"
            [placeholder]="filled ? ('Search' | translate) : ''"
            [ngClass]="{ filled: filled }"
            (click)="openSearchBar()"
            (blur)="filled = search.value ? true : false" />
        </div>
      </div>
    </div>
    <div class="event-detail-tab-items-container">
      <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 2 }" (click)="marketTypeChanged(2)">
        {{ 'OddsAll' | translate }}
      </div>

      <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 3 }" (click)="marketTypeChanged(3)">
        {{ 'OddsMatchResult' | translate }}
      </div>
      <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 7 }" (click)="marketTypeChanged(7)">
        {{ 'OddsOverUnder' | translate }}
      </div>
      <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 4 }" (click)="marketTypeChanged(4)">
        {{ 'OddsFirstHalf' | translate }}
      </div>
      <div class="event-detail-tab-item" [ngClass]="{ active: selectedMarketValue == 6 }" (click)="marketTypeChanged(6)">
        {{ 'OddsAsia' | translate }}
      </div>
    </div>
  </div>
  <div class="event-detail-tab-content">
    <ng-container *ngFor="let oddType of this.eventdetailList | groupLiveOddsByName | sortBy : true : 'SeqNumber'; let i = index">
      <div class="event-detail-odd-box">
        <div class="event-detail-odd-title">
          {{ oddType.GroupName }}
          <ng-container *ngIf="'isOddFav' | getEnv">
            <div class="fav-odd" (click)="addOdd2Favs(oddType.OddTypeId)">
              <image-loader-utils url="star" [extraClasses]="'star-icon ' + (isOddFavorite(oddType.OddTypeId) ? 'matchfavourited' : '')"></image-loader-utils>
            </div>
          </ng-container>
        </div>
        <div class="event-detail-odd-content">
          <ng-container *ngFor="let odd of oddType.eOdds | sortBy : true : 'SeqNumber' : sortedBy">
            <div
              class="event-detail-odd-button"
              *ngIf="odd.BetStatus == 2"
              (click)="clickOdd(odd)"
              [ngClass]="{
                active: checkOddId(odd.OddId) === 'active',
                'btn-single': oddType.eOdds.length == 1,
                'btn-double': oddType.eOdds.length == 2,
                'btn-triple': oddType.eOdds.length == 3,
                'btn-multiple': oddType.eOdds.length > 3
              }">
              <div class="event-detail-odd-outcome">{{ odd.OutCome }}</div>
              <div class="event-detail-odd-value">
                {{ odd.OddValue | number : '1.2-2' }}
              </div>
            </div>
            <div
              class="event-detail-odd-button lock"
              [ngClass]="{
                'btn-single': oddType.eOdds.length == 1,
                'btn-double': oddType.eOdds.length == 2,
                'btn-triple': oddType.eOdds.length == 3,
                'btn-multiple': oddType.eOdds.length > 3
              }"
              *ngIf="odd.BetStatus != 2">
              <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="top-button-container live-event-detail" (click)="ScrollToTop()">
    <div class="top-button">
      <div class="text-name">
        {{ 'back_to_top' | translate }}
      </div>
      <div class="right">
        <image-loader-utils url="up-arrow" extraClasses="arrow-icon up"></image-loader-utils>
      </div>
    </div>
  </div>
</div>
